import React, { useCallback, useState } from 'react';
import { MorePage, LiveStats } from '@colonist/clientforge';
import { StorageWrapper } from '../StorageWrapper.ts';
import { showChangeLanguageDialog } from '../ui_popup/showChangeLanguageDialog.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { StringUtils } from '@colonist/utils';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { ClientUserState } from '../ClientUserState.ts';
import { SUGGESTIONS_BOARD_URL } from '@colonist/consts';
export const MorePageContainer = ({ onRulebookClick, faqExternalUrl })=>{
    const [showCareersNotification, setShowCareersNotification] = useState(StorageWrapper.isCareersBadgeVisible());
    const onNavigate = useCallback((path)=>navigateToPage(path, false, true), []);
    const onExternalNavigate = useCallback((url)=>navigateToPage(url, true), []);
    const onPatchNotesClick = useCallback(()=>onNavigate('/patch-notes'), [
        onNavigate
    ]);
    const onFaqClick = useCallback(()=>{
        if (faqExternalUrl) onExternalNavigate(faqExternalUrl);
        else onNavigate('/faq');
    }, [
        faqExternalUrl,
        onExternalNavigate,
        onNavigate
    ]);
    const onChampionshipClick = useCallback(()=>onNavigate('/championship2026'), [
        onNavigate
    ]);
    const onPlayerHubClick = useCallback(()=>onNavigate('/community'), [
        onNavigate
    ]);
    const onSuggestionsClick = useCallback(async ()=>{
        var _ClientUserState_userState, _response_json;
        if (UIUtilsEjsVariables.isUserOnMobile) return onExternalNavigate(SUGGESTIONS_BOARD_URL);
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) return onExternalNavigate(SUGGESTIONS_BOARD_URL);
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiNoltToken());
        const url = response === null || response === void 0 ? void 0 : (_response_json = response.json) === null || _response_json === void 0 ? void 0 : _response_json.noltSsoUrl;
        if (url == undefined) return onExternalNavigate(SUGGESTIONS_BOARD_URL);
        navigateToPage(url, true);
    }, [
        onExternalNavigate
    ]);
    const onBlogClick = useCallback(()=>onExternalNavigate('https://blog.colonist.io/'), [
        onExternalNavigate
    ]);
    const onAboutClick = useCallback(()=>onNavigate('/about'), [
        onNavigate
    ]);
    const onCareersClick = useCallback(()=>{
        setShowCareersNotification(false);
        StorageWrapper.setCareersBadgeDismissed();
        onNavigate('/careers');
    }, [
        onNavigate
    ]);
    const onPrivacyClick = useCallback(()=>onNavigate('/privacy-policy'), [
        onNavigate
    ]);
    const onLanguageClick = useCallback(()=>showChangeLanguageDialog(), []);
    const liveStats = /*#__PURE__*/ React.createElement(LiveStats, {
        gamesToday: StringUtils.parseFormattedNumber(UIUtilsEjsVariables.gamesToday),
        playersOnline: StringUtils.parseFormattedNumber(UIUtilsEjsVariables.onlineCount)
    });
    return /*#__PURE__*/ React.createElement(MorePage, {
        isFaqExternal: !!faqExternalUrl,
        language: UIUtilsEjsVariables.language,
        liveStats: liveStats,
        onAboutClick: onAboutClick,
        onBlogClick: onBlogClick,
        onCareersClick: onCareersClick,
        onChampionshipClick: onChampionshipClick,
        onFaqClick: onFaqClick,
        onLanguageClick: onLanguageClick,
        onPatchNotesClick: onPatchNotesClick,
        onPlayerHubClick: onPlayerHubClick,
        onPrivacyClick: onPrivacyClick,
        onRulebookClick: onRulebookClick,
        onSuggestionsClick: onSuggestionsClick,
        showCareersNotification: showCareersNotification,
        versionNumber: UIUtilsEjsVariables.versionNumber
    });
};
